var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cameraUpload" },
    [
      _c(
        "el-upload",
        {
          ref: "changeImgList",
          attrs: {
            multiple: "",
            limit: 5,
            "file-list": _vm.fileList,
            "list-type": "picture-card",
            "before-upload": _vm.beforeUpload,
            "http-request": _vm.uploadDataClick,
            action: "",
            "on-preview": _vm.handlePreview,
            "on-remove": _vm.handleRemove,
            "on-exceed": _vm.handleExceed,
          },
        },
        [_c("i", { staticClass: "el-icon-plus" })]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: {
              width: "100%",
              height: "auto",
              margin: "0 auto",
              display: "inherit",
            },
            attrs: { src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }